import { render, staticRenderFns } from "./PageOverview.vue?vue&type=template&id=59c689b0&"
import script from "./PageOverview.vue?vue&type=script&lang=ts&"
export * from "./PageOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports